// extracted by mini-css-extract-plugin
export default {"TextAreaInput":"TextAreaInput-module-c88fddad642d272d12b4"};